import Vue from 'vue';
import { routes } from '@/router/routes.js';

export default {
  namespaced: true,
  state: () => ({
    isDrawerOpen: true,
    routeTitle: '',
    currentRoute: {},
    cachedRoutes: {},
    includedRoutes: {},
    tempBreadcrumbs: []
  }),

  getters: {
    getIsDrawerOpen: (state) => state.isDrawerOpen,
    getIncludedRoute: (state) => (name) => state.includedRoutes[name] || [],
    getRouteTitle: (state) => state.routeTitle,
    getTempBreadcrumbs: (state) => state.tempBreadcrumbs,
    getCurrentRoute: (state) => state.currentRoute
  },

  mutations: {
    setIsDrawerOpen(state, status) {
      state.isDrawerOpen = !!status;
    },
    setIncludeRoute(state, { name, routes }) {
      Vue.set(state.includedRoutes, name, routes);
    },
    setRouteTitle(state, title) {
      state.routeTitle = title;
    },
    addTempBreadcrumbs(state, item) {
      state.tempBreadcrumbs.push(item);
    },
    cleanTempBreadcrumbs(state) {
      state.tempBreadcrumbs = [];
    },
    setCurrentRoute(state, status) {
      Vue.set(state, 'currentRoute', status);
    },
    setCacheRoute(state, { name, data }) {
      Vue.set(state.cachedRoutes, name, data);
    }
  },

  actions: {
    FETCH_INCLUDE_ROUTES({ state, commit }, $route) {
      let result;
      let title;
      let includedRoute = [];
      let matched = false;
      const getRouteTitle = (routeName, _routes) => {
        if (!_routes) {
          matched = false;
          _routes = routes();
        }
        for (let i = 0; i < _routes.length; i++) {
          if (matched) {
            break;
          }

          const el = _routes[i];
          const { path, children = [], name, text, i18nKey } = el;
          if (path) {
            includedRoute.push({
              path,
              name,
              text,
              i18nKey,
              exact: true,
              disabled: el.disabled,
              params: $route.params,
              query: $route.query
            });
          }
          if (name === routeName) {
            result = text;
            matched = true;
            commit('setCurrentRoute', el);
            commit('setCacheRoute', { name, data: el });
            break;
          }
          else if (children.length) {
            getRouteTitle(routeName, children);
          }
          else if (!children.length && i + 1 === _routes.length) {
            includedRoute = [];
          }
          else {
            includedRoute.pop();
          }
        }
        return result;
      };

      const getIncludedRoute = (name) => {
        if (state.includedRoutes[name]) {
          const routes = state.includedRoutes[name];
          title = routes[routes.length - 1]?.text || '';
          return state.includedRoutes[name];
        }
        title = getRouteTitle(name);
        return includedRoute;
      };

      const cachedRoute = state.cachedRoutes[$route.name];
      if (cachedRoute) {
        commit('setCurrentRoute', cachedRoute);
      }

      commit('setIncludeRoute', {
        name: $route.name,
        routes: getIncludedRoute($route.name)
      });
      commit('setRouteTitle', title);
    }
  }
};
